import SsoVuexModule from "@abaco/sso-web-module/src/abaco-module/state";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { BuyerContractThresholdArea, ThresholdBuyerContract } from "../models/Contract";

export default class ContractApi {

    private userContracts: Record<string, ThresholdBuyerContract | null> = {};

    constructor(private http: HTTPClient, private ssoStore: SsoVuexModule){}

    public async getUsedArea(contractId: number, campaign: number): Promise<number> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/verifyUsedAreas`);
        
        const currentArea = res.data.areas.find((area: BuyerContractThresholdArea) => area.usedArea.campaign === campaign)?.usedArea.area;

        return currentArea ? currentArea / 10000 : 0;
    }

    public async getActiveContractId(): Promise<ThresholdBuyerContract | null>{
        const username = this.ssoStore.user?.username
        if(!username){
            return null;
        }
        const cachecContract = this.userContracts[username]
        if(cachecContract != undefined){
            return cachecContract;
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/getAllContractsForAdminUser/${username}`, {
            params: {
                offset: 0,
                count: 300
            },
        })
        const now = new Date().getTime();
        let minValidEndDate: number;
        let contract: ThresholdBuyerContract | null = null;
        res.data.contract.forEach((cntr: ThresholdBuyerContract) => {
            const endDate = new Date(cntr.contractEndDate).getTime();
            if(now <= endDate){
                if(!minValidEndDate || minValidEndDate > endDate){
                    minValidEndDate = endDate
                    contract = cntr;
                } 
            } 
        })
        if(contract){
            contract = contract as ThresholdBuyerContract;
            contract.areaThresholdTolerance = contract.areaThresholdTolerance ? contract.areaThresholdTolerance / 10000 : contract.areaThresholdTolerance;
            contract.areaThreshold = contract.areaThreshold ? contract.areaThreshold / 10000 : contract.areaThreshold;
        }
        this.userContracts[username] = contract;
        return contract;
    }
}